<template>
  <notificationDropdown />
</template>

<script>
import notificationDropdown from '@/views/general-component/notificationDropdown';

export default {
  components: {
    notificationDropdown,
  },
};
</script>

